<div
  *ngIf="
    resultAdvertisingCampaignPayment.partnerStatus ==
      partnerStatus.INTERNET_PROVIDER_PAYMENT;
    else revenue_sharing
  "
>
  <app-case-fsi></app-case-fsi>
</div>
<ng-template #revenue_sharing>
  <div class="card mt-36">
    <div class="card-header">
      <div class="d-flex align-items-baseline">
        <h4 class="m-r-5">{{ "location.remuneration.title" | translate }}</h4>
        <!--<i class="icofont icofont-info-circle" style="color: darkgrey"></i>-->
      </div>
      <hr style="width: 87%; margin-bottom: 0; position: absolute" />
    </div>
    <div class="card-body" *ngIf="resultAdvertisingCampaignPayment">
      <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
        {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
      </div>
      <div *ngIf="(loadingAds$ | async) && !forbidden">
        <ng-container style="float: right" class="flex">
          <div class="loader-box">
            <div class="loader-34"></div>
          </div>
          <h6 class="col align-self-center f-w-600" style="text-align: center">
            {{ "fetching" | translate }}
          </h6>
        </ng-container>
      </div>
      <div class="row" *ngIf="!(loadingAds$ | async)">
        <div class="col-12 col-xl-12">
          <div class="grid-column">
            <div class="media align-items-baseline">
              <h5 class="m-r-10">
                {{ "location.remuneration.endPhase" | translate }}
              </h5>
              {{
                resultAdvertisingCampaignPayment.pilotPhaseEndDate
                  | localizedDate
              }}
            </div>
            <div class="media align-items-baseline">
              <h5 class="m-r-10">
                {{ "location.remuneration.frequency" | translate }}
              </h5>
              {{
                PaymentFrequency[
                  resultAdvertisingCampaignPayment.paymentFrequency
                ] | translate
              }}
            </div>

            <div class="media align-items-baseline">
              <h5 class="m-r-10">
                {{ "location.remuneration.price" | translate }}
              </h5>
              {{ resultAdvertisingCampaignPayment.price }} TND
            </div>
            <div class="media align-items-baseline">
              <h5 class="m-r-10">
                {{ "location.remuneration.nextPayment" | translate }}
              </h5>
              <div>
                {{ resultAdvertisingCampaignPayment.nextPayment.toFixed(3) }}
                TND
              </div>
            </div>
          </div>
          <img
            class="ant-remuneration"
            src="assets/identity/ant-remuneration.svg"
            alt="ant"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="card">
    <div class="card-header">
      <form class="d-flex justify-content-end" [formGroup]="formFilter">
        <app-date-range-picker
          [form]="formFilter | asFormGroup"
          inputFormControlName="date"
        ></app-date-range-picker>
        <div class="m-r-10">
          <div
            class="faq-form mr-3"
            style="color: darkgrey; display: flex; margin-left: 10px"
          >
            <div>
              <div class="input-group">
                <span
                  class="input-group-text p-0"
                  style="background-color: transparent"
                >
                  <app-general-filter
                    [filter]="filterPayment"
                    (optionSelected)="saveOptionFilter($event)"
                  ></app-general-filter>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex mb-3">
          <app-refresh-button
            [state]="fetchingCampaignsSate"
            [date]="cachedAt"
            (buttonClick)="fetchCampaigns(true)"
          ></app-refresh-button>
        </div>
      </form>
    </div>
    <div class="card-body pt-0">
      <div class="table-responsive data-table" style="font-size: 12px">
        <table class="table table-striped table-border-vertical">
          <thead>
            <tr>
              <ng-container *ngFor="let column of columns">
                <th>
                  {{ column.label | translate }}
                </th>
              </ng-container>
            </tr>
          </thead>
          <tbody *ngIf="!(loadingAds$ | async)">
            <tr *ngFor="let ad of advertisingCampaigns; let i = index">
              <td>
                {{ ad.title }}
                <i
                  class="icofont icofont-check-circled color-success"
                  *ngIf="ad.isPaid; else notPaid"
                ></i>
                <ng-template #notPaid>
                  <i
                    *ngIf="!ad.isPaid"
                    class="icofont icofont-close-circled"
                    style="color: red"
                  ></i>
                </ng-template>
              </td>
              <td>
                {{ ad.startDate | localizedDate }}
              </td>
              <td>
                {{ ad.endDate | localizedDate }}
              </td>
              <td>
                {{ ad.impressions }}
              </td>
              <td>
                <span
                  [ngClass]="
                    'badge ' +
                    badgeService.getBadgeForAdvertisingCampaingStatus(ad.status)
                  "
                >
                  {{ "enumMapping.campaigns.status." + ad.status | translate }}
                </span>
              </td>
              <td>
                <span
                  [ngClass]="
                    'badge ' +
                    badgeService.getBadgeForLPRemuneration(
                      ad.remunerationStatus
                    )
                  "
                >
                  {{
                    remunerationEnumMapping[ad.remunerationStatus] | translate
                  }}
                </span>
              </td>
              <td>
                {{ ad.revenueAmount.toFixed(3) }} TND
                <app-info-tooltip-component
                  *ngIf="showTooltip(ad.remunerationStatus)"
                  [infoTooltip]="
                    getRevenueTooltip(
                      ad.paidImpressions,
                      ad.paidPeriodStart,
                      ad.paidPeriodEnd
                    )
                  "
                  [placement]="'left'"
                ></app-info-tooltip-component>
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="forbidden" class="d-flex justify-content-center m-t-20">
          {{ "response.error.FORBIDDEN_RESPONSE" | translate }}
        </div>
        <div *ngIf="(loadingAds$ | async) && !forbidden">
          <ng-container style="float: right" class="flex">
            <div class="loader-box">
              <div class="loader-34"></div>
            </div>
            <h6
              class="col align-self-center f-w-600"
              style="text-align: center"
            >
              {{ "fetching" | translate }}
            </h6>
          </ng-container>
        </div>
        <div
          *ngIf="advertisingCampaigns.length == 0 && !(loadingAds$ | async)"
          class="d-flex justify-content-center m-t-20"
        >
          {{ "noData" | translate }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
